import { makeStyles } from '@mui/styles';
import backgroundImage from '../../assets/images/HeroSectionImg.jpg';

const useHeroSectionStyles = makeStyles((theme) => ({
  heroSection: {
    paddingLeft: '7rem',
    position: 'relative',
    height: '100vh',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#fff',
    padding: '0 5rem',
    boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.3)',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '6rem',

    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '3rem',
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
      justifyContent: 'center',
      backgroundPosition: 'left',
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '50px',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)',
      zIndex: 2,
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },
  content: {
    position: 'relative',
    zIndex: 2,
    maxWidth: '49%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      textAlign:'center',
      maxWidth: '100%',
      alignItems: 'center',
    },
  },
  heading: {
    fontWeight: 'bold ',
    fontSize: '3rem !important',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    marginBottom: '1rem',
    [theme.breakpoints.down('md')]: {
        fontSize: '3.5rem !important',
        paddingBottom: '3rem',
        paddingTop: '1.5rem',
    },
  },
  text: {
    fontSize: '1.2rem !important',
    paddingBottom: '1.5rem',
    marginBottom: '2rem',
    color: '#dedcdc',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.3rem !important',
      paddingBottom: '3rem',
      marginBottom: '1rem !important',
    },
  },
  exploreButton: {
    marginRight: '0 !important',
    paddingLeft: '2rem !important',
    paddingRight: '2rem !important',
    paddingTop: '0.7rem !important',
    paddingBottom: '0.7rem !important',
    textTransform: 'none !important',
    fontSize: '1rem',
    backgroundColor: '#fff !important',
    color: theme.palette.text.primary,
    fontWeight: 'bold !important',
    border: 'none',
    borderRadius: '5px !important',
    boxShadow: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 7px rgba(255, 255, 255, 0.29) !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem !important',
      padding: '1.3rem 2.5rem !important',
      width: '100%',
      maxWidth: '300px',
      borderRadius: '12px !important',
    },
  },
  readMoreButton: {
    marginLeft:'0rem!important',
    paddingLeft: '2rem !important',
    paddingRight: '2rem !important',
    paddingTop: '0.7rem !important',
    paddingBottom: '0.7rem !important',
    textTransform: 'none !important',
    fontSize: '1rem',
    color: '#fff !important',
    border: '#fff',
    fontWeight: 'bold !important',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.31)',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem !important',
      padding: '1.3rem 2.5rem !important',
      width: '100%',
      maxWidth: '300px',
      borderRadius: '12px !important',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '1rem',
    marginTop: '1rem',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
    },
  },

}));

export default useHeroSectionStyles;